import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'neighFilter'
})
export class NeighbourhoodPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;

    searchText = searchText.toLowerCase();

    return items.filter(it => {
      const name = it.neigh_name?.toLowerCase() || '';
      const uid = String(it.neigh_uid || '').toLowerCase();
      return name.includes(searchText) || uid.includes(searchText);
    });
  }
}
